// Add available reference currencies here
const ReferenceCurrencies = {
  EUR: 'EUR',
  // GBP: 'GBP',
  // HKD: 'HKD',
  // SGD: 'SGD',
  // USD: 'USD',
  // CAD: 'CAD',
  // TRY: 'TRY',
  // CHF: 'CHF',
  // PLN: 'PLN',
  // SEK: 'SEK',
  // DKK: 'DKK'
};

module.exports = ReferenceCurrencies;
